<template>
	<core-select-product
		:value="value"
		:insuranceType="insuranceType"
		:allowSelectNothing="false"
		@input="onInput"
	/>
</template>

<script>
import CoreSelectProduct from "@/modules/core/components/CoreSelectProduct"

export default {
	components: { CoreSelectProduct },
	props: {
		value: {
			validator(val) {
				return val === undefined || val === null || Array.isArray(val)
			},
			required: false,
			default: () => []
		},

		insuranceType: {
			type: String,
			default: ""
		}
	},

	methods: {
		onInput(value) {
			// Prevent selecting nothing
			if (!value?.length) return

			this.$emit("input", value)
			this.$emit("updated", value)
		}
	}
}
</script>
